import { createFileRoute } from '@tanstack/react-router'
import { FieldsSettingsPage } from '../../../modules/settings/fields-settings-page'
import { SettingsShell } from '../../../modules/settings/settings-shell'

export const Route = createFileRoute('/_authed/settings/fields')({
  component: () => (
    <SettingsShell>
      <FieldsSettingsPage />
    </SettingsShell>
  ),
})
